import { useCounter, useEffectOnceWhen } from "rooks";
import { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../store/hooks";
import { pollingSelector } from "../../../../../../../store/account-setup/selectors/pollingSelector";
import { accountAttemptSelector } from "../../../../../../../store/account-setup/selectors/accountAttemptSelector";
import { missingSubAccountRoleAccountIdSelector } from "../../../../../../../store/account-setup/selectors/missingSubAccountRoleAccountIdSelector";
import {
  goToNextStep,
  setAccountAttempt,
  setPolling,
  setPollingInterrupted,
} from "../../../../../../../store/account-setup/accountSetupSlice";
import {
  AccountAttempt,
  useGetUsersMeAccountsQuery,
} from "../../../../../../../services/cloudchipr.api";
import { accountsNeedToFetchStatuses } from "../../../../../../../store/accounts/utils/constants/common";
import {
  accountSetupPollingInterval,
  accountSetupPollingLimit,
} from "../utils/constants";

export const useSetMissingSubAccountPollingProgress = () => {
  const dispatch = useAppDispatch();
  const polling = useAppSelector(pollingSelector);
  const accountAttempt = useAppSelector(accountAttemptSelector);
  const subAccountId = useAppSelector(missingSubAccountRoleAccountIdSelector);

  const { increment, value } = useCounter(0);

  const { data, requestId } = useGetUsersMeAccountsQuery(
    {
      statuses: accountsNeedToFetchStatuses,
    },
    {
      skip: !accountAttempt,
      pollingInterval: polling ? accountSetupPollingInterval : 0,
    },
  );

  useEffect(increment, [requestId, increment]);

  useEffectOnceWhen(() => {
    dispatch(setPolling(false));
    dispatch(setPollingInterrupted(true));
  }, value === accountSetupPollingLimit);

  useEffectOnceWhen(() => {
    dispatch(goToNextStep());
  }, accountAttempt?.status === "closed");

  useEffectOnceWhen(() => {
    dispatch(setPolling(false));
  }, accountAttempt?.status === "failed");

  useEffect(() => {
    const selectedAccount = data?.find((item) => item.id === subAccountId);

    if (selectedAccount?.status === "connected" && accountAttempt) {
      const localAccountAttempt: AccountAttempt = {
        status: "confirmed",
        id: selectedAccount.id,
        type: "aws",
        account_id: selectedAccount?.id,
        created_at: selectedAccount.created_at,
        user_id: selectedAccount.user_id,
        access_type: selectedAccount.access_type,
        status_details: accountAttempt?.status_details,
      };

      if (localAccountAttempt) {
        dispatch(setPolling(false));
        dispatch(setAccountAttempt(localAccountAttempt));
        dispatch(goToNextStep());
      }
    }
  }, [data, dispatch, subAccountId, accountAttempt]);
};
